import { ComponentProps } from 'react';
import { AVPlaybackSourceObject, ResizeMode } from 'expo-av';

export type MediaPlayerProps = {
	source: AVPlaybackSourceObject & {
		thumbnailUrl?: string | null;
		thumbnailBlurhash?: string | null;
	};
	style: ComponentProps<typeof VideoPlayer>['style'];
	autoPlay?: boolean;
	resizeMode?: ResizeMode;
	playerVisible?: boolean;
};
